module.exports = __webpack_public_path__ + "static/img/game.ad48f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/game.jpg
// module id = Gnt+
// module chunks = 1